import { __module as e } from "../../../../../_virtual/jsx-runtime.mjs";
import { __require as r } from "./cjs/react-jsx-runtime.production.min.mjs";
import { __require as o } from "./cjs/react-jsx-runtime.development.mjs";
process.env.NODE_ENV === "production" ? e.exports = r() : e.exports = o();
var m = e.exports;
export {
  m as j
};
